import { z } from 'zod';
export const localizedTextSchema = z.record(z.string().min(1), z.string().min(1));
export const pricingPlanSchema = z.object({
    id: z.string().uuid(),
    planKey: z.string().min(1),
    displayName: localizedTextSchema,
    priceMonthlyEur: z.number().nonnegative().nullable(),
    priceAnnualEur: z.number().nonnegative().nullable(),
    trialDays: z.number().int().nonnegative(),
    featureBullets: z.array(z.string().min(1)),
    highlight: z.boolean(),
    rcProductIds: z.array(z.string().min(1)),
    active: z.boolean(),
    sort: z.number().int(),
    effectiveFrom: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const publicPricingResponseSchema = z.object({
    plans: z.array(pricingPlanSchema),
});
export const adminPricingPlansResponseSchema = z.object({
    plans: z.array(pricingPlanSchema),
});
export const adminPricingPlanResponseSchema = z.object({
    plan: pricingPlanSchema,
});
export const adminPricingPlanMutationSchema = pricingPlanSchema
    .pick({
    planKey: true,
    displayName: true,
    priceMonthlyEur: true,
    priceAnnualEur: true,
    trialDays: true,
    featureBullets: true,
    highlight: true,
    rcProductIds: true,
    active: true,
    sort: true,
    effectiveFrom: true,
})
    .extend({
    planKey: z
        .string()
        .min(1)
        .regex(/^[a-z0-9][a-z0-9_-]*$/),
});
export const adminPricingPlanPatchSchema = adminPricingPlanMutationSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, { message: 'At least one field is required' });
//# sourceMappingURL=pricing-plan.js.map